import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AboutUsPages } from 'src/app/models/aboutUs-pages.model';
import { AboutUsService } from 'src/app/services/about-us.service';

@Component({
  selector: 'app-hometwo-about',
  templateUrl: './hometwo-about.component.html',
})
export class HometwoAboutComponent implements OnInit {
  aboutUsPages: AboutUsPages | undefined;

  constructor(private aboutUsService: AboutUsService,
  ) { }

  ngOnInit(): void {
    this.aboutUsService.getAll$().subscribe(x => {
      this.aboutUsPages = x.find(x => x.pageID == 1);
    });
  }
  createImgPath = (serverPath: string) => {
    return this.aboutUsService.createImgPath(serverPath);
  }
} 
